import { render, staticRenderFns } from "./bang-ding-org.vue?vue&type=template&id=6e711c14&scoped=true"
import script from "./bang-ding-org.vue?vue&type=script&setup=true&lang=ts"
export * from "./bang-ding-org.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e711c14",
  null
  
)

export default component.exports